export default "__VITE_ASSET__CleMRqnE__"